import {
  xDaEstruturaNaAltura,
  zDaColunaNaAltura,
  type PerfilVeiculo,
} from '../../dominio/didatico/perfilVeiculo'
import { multiplicar, subtrair, vetor, type Vetor3 } from '../../dominio/geometria/vetor3'

/** Quanto a coluna desce abaixo da linha de cintura, para entrar na chapa da porta. */
const DESCIDA_ABAIXO_DA_CINTURA_M = 0.02

/** Distância acima da cintura usada para medir a inclinação da coluna ali. */
const PASSO_DA_TANGENTE_M = 0.05

/**
 * Pontos da polilinha que desenha uma coluna, da cintura ao teto.
 *
 * A posição de uma coluna é função da altura e para de variar abaixo da cintura
 * (`t` é limitado a [0, 1]). Medir o primeiro ponto nos 2 cm abaixo da cintura
 * dava uma coluna sem inclinação ali, e o primeiro trecho nascia com uma quebra
 * de 4 a 8° em relação ao seguinte: o vinco mais visível da coluna. O primeiro
 * ponto vem da tangente da própria curva na cintura, e o trecho continua
 * naturalmente.
 */
export function pontosDaColuna(
  perfil: PerfilVeiculo,
  coluna: { zBase: number; zTopo: number },
  sinal: number,
  trechos = 4,
): Vetor3[] {
  const amostra = (y: number) => vetor(xDaEstruturaNaAltura(perfil, sinal, y), y, zDaColunaNaAltura(perfil, coluna, y))
  const base = perfil.cinturaY - DESCIDA_ABAIXO_DA_CINTURA_M

  const pontos = Array.from({ length: trechos + 1 }, (_, i) => amostra(base + ((perfil.tetoY - base) * i) / trechos))

  const naCintura = amostra(perfil.cinturaY)
  const acima = amostra(perfil.cinturaY + PASSO_DA_TANGENTE_M)
  pontos[0] = subtrair(
    naCintura,
    multiplicar(subtrair(acima, naCintura), DESCIDA_ABAIXO_DA_CINTURA_M / PASSO_DA_TANGENTE_M),
  )
  return pontos
}
